import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, pipe } from 'rxjs';

import { DataService } from '../services';

import { redirectTo404 } from './404.guard';

const redirectOnErrorPipe = (router: Router) =>
  pipe(
    map(() => true),
    catchError(() => {
      return of(redirectTo404(router));
    }),
  );

export const canActivateBackofficeFn: CanActivateFn = () => {
  const router = inject(Router);
  return inject(DataService)
    .retrieveOrFetchBackofficeInstance()
    .pipe(redirectOnErrorPipe(router));
};
export const canActivateFrontOfficeFn: CanActivateFn = () => {
  const router = inject(Router);
  return inject(DataService)
    .fetchFrontofficeInstance()
    .pipe(redirectOnErrorPipe(router));
};

export const frontofficeGuards = [canActivateFrontOfficeFn];
export const backofficeGuards = [canActivateBackofficeFn];
